<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>{{ flag ? 'Importar contabilidad' : 'Importar apertura' }}</span>
  <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content style="padding:16px 24px;min-width:0">

  <ng-container *ngIf="flag === false">
    <p style="font-weight:600;margin:0 0 10px">Importación de apertura mediante Excel</p>
    <p style="font-size:13.5px;color:#374151;margin:0 0 10px;line-height:1.6">
      Mediante el siguiente proceso podrá importar sus asientos de apertura a Handly
      mediante una plantilla en Excel. Dicha plantilla deberá tener el formato indicado en el ejemplo.
    </p>
    <p style="font-size:13.5px;color:#374151;margin:0 0 16px;line-height:1.6">
      Una vez haya cumplimentado la plantilla correctamente, súbala en el siguiente paso y verá una vista previa.
    </p>

    <div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:20px">
      <button mat-stroked-button (click)="downloadTemplateApertura()">
        <mat-icon>file_download</mat-icon>
        Descargar plantilla
      </button>
    </div>

    <div style="display:flex;align-items:center;gap:12px">
      <span style="font-size:13.5px;color:#374151;font-weight:500">Importar Apertura</span>
      <input type="file" (change)="fileChange($event, false)" accept=".xlsx" style="font-size:13px">
    </div>

    <ng-container *ngIf="dataReady">
      <ng-container *ngIf="!working">
        <div style="margin-top:16px">
          <app-table [columns]="headerTable" [dataSource]="dataSource"></app-table>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="flag === true">
    <p style="font-weight:600;margin:0 0 10px">Importación de contabilidad mediante Excel</p>
    <p style="font-size:13.5px;color:#374151;margin:0 0 10px;line-height:1.6">
      Mediante el siguiente proceso podrá importar sus asientos a Handly mediante una plantilla en Excel.
    </p>
    <p style="font-size:13px;color:#dc2626;margin:0 0 10px;line-height:1.6">
      Tenga en cuenta que no podrá importar ingresos, gastos o movimientos de tesorería,
      debido a la entidad a la que están relacionadas en Handly.
    </p>
    <p style="font-size:13.5px;color:#374151;margin:0 0 16px;line-height:1.6">
      Una vez haya cumplimentado la plantilla correctamente, súbala y verá una vista previa de los datos.
    </p>

    <div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:20px">
      <button mat-stroked-button (click)="downloadTemplateContabilidad()">
        <mat-icon>file_download</mat-icon>
        Descargar plantilla
      </button>
    </div>

    <div style="display:flex;align-items:center;gap:12px">
      <span style="font-size:13.5px;color:#374151;font-weight:500">Importar Contabilidad</span>
      <input type="file" (change)="fileChange($event, true)" accept=".xlsx" style="font-size:13px">
    </div>

    <ng-container *ngIf="dataReady">
      <ng-container *ngIf="!working">
        <div style="margin-top:16px">
          <app-table [columns]="headerTable" [dataSource]="dataSource"></app-table>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
</mat-dialog-actions>
